import React from 'react';

import { MainOptionalTrainingMainProps } from './Type';
import CustomHeader from '../CustomHeader';
import {
  getHeaderLevel,
  getTextAlignmentClass,
  getTextColorClass,
} from '../../../services/generalUtils';
import { mapTrainingFieldsToProps } from '../mapTrainingFieldsToProps';
import SpecificTrainingMain from '../specific-training/SpecificTrainingMain';
import OnDemandTrainingsMain from '../on-demand-training/OnDemandTrainingsMain';
import { themeColor } from '../../../services/styleUtils/colorUtils';
import theme from '../../../styles/theme';

const TrainingOptionsMain = ({
  mainTitle,
  mainTitleStyle,
  specificTrainings,
  commonComponent,
  backgroundStyle,
}: MainOptionalTrainingMainProps) => {
  const backgroundColor = backgroundStyle?.fields?.color
    ? themeColor(theme, backgroundStyle?.fields?.color)
    : null;
  return (
    <section
      className="mt-[50px]"
      style={backgroundColor ? { backgroundColor } : undefined}
    >
      <CustomHeader
        text={mainTitle}
        headerStyle={{
          color: getTextColorClass(themeColor(theme, mainTitleStyle?.color)),
          level: getHeaderLevel(mainTitleStyle?.level),
          className: `${getTextAlignmentClass(mainTitleStyle?.alignment)} pt-[34px] font-['Source_Sans_3'] font-semibold text-[26px] leading-[24px] uppercase lg:text-[26px] lg:leading-[24px] lg:font-semibold`,
        }}
      />
      {commonComponent && <OnDemandTrainingsMain {...commonComponent} />}
      {Array.isArray(specificTrainings) &&
        specificTrainings.length > 0 &&
        specificTrainings.map((training, idx) => {
          const fields = training.fields || {};
          return (
            <SpecificTrainingMain
              key={idx}
              {...mapTrainingFieldsToProps({
                ...fields,
                expandOnLanding: idx === 0 ? 'true' : fields.expandOnLanding,
              })}
            />
          );
        })}
    </section>
  );
};

export default TrainingOptionsMain;
